module.exports = __webpack_public_path__ + "static/img/knyy_zzfx_icon.png";